<template>
  <div v-if="country">
    <app-header :title="'Edit ' + country.name + ' Settings'">
      <b-button variant="primary" class="mr-1" @click="save()">
        Save Changes
      </b-button>
      <cancel-button />
    </app-header>
    <b-container>
      <b-row>
        <b-col md="4">
          <form name="editorForm">
            <b-form-group>
              <label>Print Cut Price ({{ country.currency }})</label>
              <b-form-input v-model="country.printcutprice" type="number" class="form-control"></b-form-input>
            </b-form-group>

            <b-form-group>
              <label>Cut-Only Price ({{ country.currency }})</label>
              <b-form-input v-model="country.cutonlyprice" type="number" class="form-control"></b-form-input>
            </b-form-group>
          </form>
        </b-col>
        <b-col md="8"></b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import $api from '@/services/api';
import AppHeader from '@/components/AppHeader';
import CancelButton from '@/components/CancelButton';

export default {
  components: {
    AppHeader,
    CancelButton,
  },

  data() {
    return {
      country: null,
    };
  },

  created() {
    this.refreshData();
  },

  methods: {
    async save() {
      $api.put(`/v1/internal/countries/${this.country.id}`, this.country);
      this.$router.push({
        name: 'country-detail',
        params: this.country,
      });
    },

    async refreshData() {
      this.country = await $api.get(`/v1/internal/countries/${this.$route.query.id}`);
    },
  },
};
</script>
